import { socketTransport } from './socketTransport';

export const loggerClient = {
  worker: new Worker(new URL('./worker/logger.worker.js', import.meta.url)),
  getAppId: () => {
    let appId = sessionStorage.getItem('appId');
    if (!appId) {
      appId = crypto.randomUUID();
      sessionStorage.setItem('appId', appId);
    }

    return appId;
  },
  log(level, args) {
    const entry = {
      appId: this.getAppId(),
      args,
      id: crypto?.randomUUID(),
      level,
      logTime: Date.now(),
      source: 'web-app',
      userId: localStorage.getItem('Id'),
      userAgent: navigator.userAgent,
    };
    this.worker.postMessage({
      type: 'LOG',
      payload: entry,
    });
  },
};

loggerClient.worker.onerror = function (e) {
  console.error('[logger worker error]', e);
};

loggerClient.worker.onmessage = async function (e) {
  if (e.data.type === 'SEND_BATCH') {
    const batch = e.data.batch;

    if (socketTransport.isReady()) {
      try {
        const ok = await socketTransport.send(batch);

        if (ok) {
          const ids = batch.map((l) => l.id);
          loggerClient.worker.postMessage({ type: 'ACK', ids });
        }
      } catch (e) {}
    }
  }
};
